<template lang="pug">
    div
        v-select(
            class="style-chooser"
            :options="options" 
            :multiple="multiple"
            :placeholder="$t('home.selectServerNameText')"
            @search="onSearch"
            :filterable="false"
            :value="$store.state.dashboard.queryFilter.serverNames"
            @input="updateValue"
            :taggable="taggable"
            :createOption="createOption"
        )
            span(slot="no-options") {{ $t('main.selectNotFoundText') }}
</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import { _debounce, isSameJson } from "@/libs/utils";
export default {
    name: "ServerNameSelector",
    components: {},
    props: {
        multiple: { type: Boolean, default: true },
        taggable: { type: Boolean, default: true },
    },
    watch: {
        groupNames: function(newVal, oldVal) {
            if (!isSameJson(newVal, oldVal)) {
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "serverNames", value: [] });
                this.getOptions();
            }
        },
        serviceGroupNames: function(newVal, oldVal) {
            if (!isSameJson(newVal, oldVal)) {
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "serverNames", value: [] });
                this.getOptions();
            }
        },
        appProfileNames: function(newVal, oldVal) {
            if (!isSameJson(newVal, oldVal)) {
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "serverNames", value: [] });
                this.getOptions();
            }
        },
        tags: function(newVal, oldVal) {
            if (!isSameJson(newVal, oldVal)) {
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "serverNames", value: [] });
                this.getOptions();
            }
        }
    },
    data() {
        return {
            options: []
        };
    },
    computed: {
        groupNames() {
            let groupNames = this.$store.state.dashboard.queryFilter.groupNames;
            return groupNames.length > 0 ? groupNames : "*";
        },
        serviceGroupNames() {
            let serviceGroupNames = this.$store.state.dashboard.queryFilter.serviceGroupNames;
            return serviceGroupNames.length > 0 ? serviceGroupNames : "*";
        },
        appProfileNames() {
            let appProfileNames = this.$store.state.dashboard.queryFilter.appProfileNames;
            return appProfileNames.length > 0 ? appProfileNames : "*";
        },
        tags() {
            let tags = this.$store.state.dashboard.queryFilter.tags;
            return tags.length > 0 ? tags : "*";
        },
        getOptionsQueryString() {
            let searchParams = {};
            searchParams.groupNames = this.groupNames;
            searchParams.serviceGroupNames = this.serviceGroupNames;
            searchParams.appProfileNames = this.appProfileNames;
            searchParams.tags = this.tags;
            return new URLSearchParams(searchParams).toString();
        }
    },
    methods: {
        getOptions() {
            getFormOptions(`/servernamesfordashboard?${this.getOptionsQueryString}`).then(res => {
                this.options = Array.from(
                    new Map(
                        (res.data.options || []).map(o => {
                            const value = typeof o === "string" ? o : o.value;
                            const label = typeof o === "string" ? o : o.label;

                            return [
                                value,
                                {
                                    label,
                                    value,
                                }
                            ];
                        })
                    ).values()
                );
            });
        },
        updateValue(valueArray) {
            const value = valueArray.map(e => (e && e.value ? e.value : e));
            // console.log(`update value with ${value}`);
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "serverNames", value: value });
        },
        onSearch(queryValue, loading) {
            // console.log(queryValue);
            // console.log(loading);
            this.getOptionsDebounce(queryValue, loading);
        },
        createOption(newOption) {
            return {
                label: newOption,
                value: newOption,
            };
        },
    },
    mounted() {
        this.getOptions();
    },
    created() {
        var self = this;
        this.getOptionsDebounce = _debounce(function(queryValue, loading) {
            // console.log(`Trigger debounce search for value: ${queryValue}`);
            loading(true);
            queryValue = queryValue || "";
            getFormOptions(`servernamesfordashboard?&serverNames=*${queryValue}*&${self.getOptionsQueryString}`).then(
                res => {
                    self.options = Array.from(
                        new Map(
                            (res.data.options || []).map(o => {
                                const value = typeof o === "string" ? o : o.value;
                                const label = typeof o === "string" ? o : o.label;

                                return [
                                    value,
                                    {
                                        label,
                                        value,
                                    }
                                ];
                            })
                        ).values()
                    );
                    loading(false);
                }
            );
        });
    },
    destroyed() {},
    beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/ServerNameSelector.vue